import { commonRegx } from "xcommon-node/src/common/commonRegx";

export class DtoFileMastersGetReq {}
